import React, { Component } from "react";
import { Card, Button } from "react-bootstrap";
import "../../css/Managehssestyle.css";
import 'bootstrap/dist/css/bootstrap.css';
import '../../css/customBootstrapExtended.css';
import '../../css/UpdateUserProfile.css';
import '../../css/MyReportstylee.css';

import GroupVRNSelect from '../../containers/comps/GroupVRNSelectContainer'


import Stepper from 'react-stepper-horizontal';
import { Link } from 'react-router-dom'; // Add this line


function Iframe(props) {
  console.log("URL Calling : ", props.src)
  return (
    <div>
      <iframe src={props.src} height={props.height} width={props.width} allowFullScreen={true} style={{ border: 0 }} />
    </div>
  )
}

const currentDate = new Date();


class TrendReports extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showReport: false,
      showTrendReport: false,
      srcTrendURL: '',
      //reportBaseURL: 'http://localhost:40383/Reports?',
      reportBaseURL: 'https://shelltelematics.pk/TELEMATICSREPORTINGSERVICE/Reports?',
      reportExtraParams: '&rs:Command=Render&rc:Parameters=false&',
      reportViewType: '/SSSAS_TabularReports/',
      UserBranchID: this.props.data.selectedBranchId,
      reportDuration: 3,
      reportName: '',
      reportStartDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2).toISOString().substring(0, 10),
      reportEndDate: new Date().toISOString().substring(0, 10),
      trendReportType: '',
      trendReportDuration: '',
      TrendReportsteps: [
        {
          title: 'Step One',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 1)
          }
        },
        {
          title: 'Step Two',
          onClick: (e) => {
            e.preventDefault()
            console.log('onClick', 2)
          }
        }
      ],
      TRcurrentStep: 0,

      PageSize: 5,
      Option: 1,
      Group: 0,
      Vehicle: 0,
      TrendOption: 1,
      TrendGroup: 0,
      TrendVehicle: 0,

    };

    this.onClickNext_TR = this.onClickNext_TR.bind(this);
    this.onClickPrevious_TR = this.onClickPrevious_TR.bind(this)

    this.handleChange = this.handleChange.bind(this)

    this.TrendoptionChange = this.TrendoptionChange.bind(this)
    this.TrendgroupChange = this.TrendgroupChange.bind(this)
    this.TrendvehicleChange = this.TrendvehicleChange.bind(this)

    this.trendReportSubmitHandler = this.trendReportSubmitHandler.bind(this)
  }

  onClickNext_TR() {
    if (this.state.TRcurrentStep < 1)
      this.setState({
        TRcurrentStep: this.state.TRcurrentStep + 1,
      });
  }

  onClickPrevious_TR() {
    if (this.state.TRcurrentStep > 0)
      this.setState({
        TRcurrentStep: this.state.TRcurrentStep - 1,
      });
  }

  fetchReport() {
    this.setState({ showReport: true })
  }

  async TrendoptionChange(selectedOption) {
    if (this.state.TrendOption != selectedOption && selectedOption == 1) {
      await this.setState({ TrendOption: selectedOption, TrendGroup: 0, TrendVehicle: 0 })

    }
    else
      this.setState({ TrendOption: selectedOption, TrendGroup: 0, TrendVehicle: 0 })
  }

  async TrendvehicleChange(selectedVehicle) {
    await this.setState({ TrendVehicle: selectedVehicle, TrendGroup: 0 })
    //this.getAnalyticsData()

  }

  async TrendgroupChange(selectedGroup) {

    await this.setState({ TrendGroup: selectedGroup, TrendVehicle: 0 })

  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  trendReportSubmitHandler(e) {
    e.preventDefault();
    this.setState({ showTrendReport: false })

    let UserBranchID = this.state.UserBranchID
    let reportDuration = this.state.trendReportDuration

    let reportName = this.state.trendReportType
    let reportViewType = this.state.reportViewType

    let URL_PARAMETERS = 'reportName=' + reportName + '&DateRange=' + reportDuration + '&SelectedCriteria=' + 'vrn' + '&userBranchID=' + UserBranchID + '&token=' + localStorage.getItem('token')

    if (this.state.TrendOption == '2' || this.state.TrendOption == '3') {
      if (this.state.TrendOption == '2')
        URL_PARAMETERS += '&VRNGroupingID=' + this.state.TrendGroup
      else if (this.state.TrendOption == '3')
        URL_PARAMETERS += '&MappingMasterID=' + this.state.TrendVehicle
    }

    let ReportFullURL = this.state.reportBaseURL + URL_PARAMETERS
    this.setState({ srcTrendURL: ReportFullURL, showTrendReport: true })
  }

  componentDidMount() {
  }

  render() {
    const { TrendReportsteps, TRcurrentStep } = this.state;
    const buttonStyle = { background: '#E0E0E0', width: 200, padding: 16, textAlign: 'center', margin: '0 auto', marginTop: 32 };

    return (
      
      <div>
         
          <div style={{ textAlign: 'left', marginLeft: '30px' }}>

<Link to="/EventAndReports" className="btn btn-shell mr-1 mb-1">Back</Link> {/* Add this line */}

</div>
        <div className="row">
        <div className="col-sm-12">
                            <Card>
                              <Card.Title className="card-header">
                                Fleet Overview Report
                              </Card.Title>
                              <Card.Body>

                                <Stepper
                                  steps={TrendReportsteps}
                                  activeStep={TRcurrentStep}
                                  activeColor="#ffd500"
                                  defaultBarColor="#ffd500"
                                  completeColor="red"
                                  // completeColor="red"
                                  completeBarColor="#ffd500"
                                  defaultBorderColor="green"
                                />


                                {TRcurrentStep === 0 && (
                                  <>


                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 'calc(20vh - 20px)' }}>
                                      <GroupVRNSelect
                                        showVehiclesInDropDown='yes'
                                        isMultiInGroup='false'
                                        isMultiInVehicle='false'
                                        onOptionChange={this.TrendoptionChange}
                                        onGroupChange={this.TrendgroupChange}
                                        onVehicleChange={this.TrendvehicleChange}
                                      ></GroupVRNSelect>
                                    </div>


                                  </>

                                )}


                                {TRcurrentStep === 1 && (
                                  <>
                                    <form className="form" onSubmit={this.trendReportSubmitHandler}>
                                      <div className="form-body">
                                        <div className="row">
                                          <div className="col-md-6 col-12">
                                            <div className="form-group">
                                              {/* <label htmlFor="ReportType">Choose Trend</label> */}
                                              {/* <p className="text-left">Choose Trend</p> */}
                                              <p className="text-left">Trend</p>
                                              <select
                                                className="custom-select form-control"
                                                id="location1"
                                                name="trendReportType"
                                                onChange={this.handleChange.bind(this)}
                                                required
                                              >
                                                {/* <option value="">
                                                  Please Select
                                                </option>

                                                <option value="SafetyIncidentsTrend">
                                                Safety Incidents
                                                </option> */}
                                                <option value="FleetOverviewReport">
                                                Fleet Overview Report
                                                </option>
                                                {/* <option value="ShellCardSuspeciousTransactions">
                                                  Suspicious Transactions (No. & PKR)
                                                </option>
                                                <option value="SafetyScoreTrend">
                                                Safety Score
                                                </option> */}
                                              </select>
                                            </div>
                                          </div>

                                          <div className="col-md-6 col-12">
                                            <div className="form-group">
                                              <p className="text-left">Choose Time Frame</p>
                                              <select
                                                className="custom-select form-control"
                                                id="location1"
                                                name="trendReportDuration"
                                                onChange={this.handleChange.bind(this)}
                                                required
                                              >
                                                <option value="">
                                                  Please Select
                                                </option>
                                                <option value="Three_Month">
                                                  Last 3 months
                                                </option>
                                                <option value="Six_month">
                                                  Last 6 months
                                                </option>
                                                <option value="Nine_Month">
                                                  Last 9 months
                                                </option>
                                                <option value="Year">
                                                  Last 12 months
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                          <div className="col-12">
                                            <button type="submit" className="btn btn-shell mr-1 mb-1">Generate Trend</button>
                                          </div>
                                          <div className="col-md-12 col-12" id='number'>
                                            {this.state.showTrendReport && <Iframe src={this.state.srcTrendURL} height="800" width="100%" />}
                                          </div>


                                        </div>
                                      </div>
                                    </form>

                                  </>
                                )}

                                <div >
                                  
                                {this.state.TRcurrentStep != 0 && 
                                  <div class="pull-left"><Button className="btn-shell" variant="warning" onClick={this.onClickPrevious_TR}>Previous</Button></div>
                                }

                                {this.state.TRcurrentStep != 1 &&
                                  <div class="pull-right"><Button className="btn-shell" variant="warning" onClick={this.onClickNext_TR}>Next</Button></div>
                                
                                }
                                
                                </div>


                              </Card.Body>
                            </Card>

                            </div>

                  </div>

      </div>


    );
  }
}
export default TrendReports;